import script from "./ServerDetailPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerDetailPanel.vue?vue&type=script&setup=true&lang=js"

import "./ServerDetailPanel.vue?vue&type=style&index=0&id=4ca6225f&lang=scss"

const __exports__ = script;

export default __exports__